// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageInfo from '../../package.json'

export const environment = {
  production: false,
  analyticsKey: 'UATAnalytics',
  progressKey: 'Progress',
  name: 'modal',
  appName: 'Modal',
  urlScheme: 'modalantiinfectives',
  appId: 'com.modaldigital.antiinfectives',
  version: packageInfo.version,
  homePage: [''],
  scormEngine: 'https://api.uat.anti-infectives.modaldigital.io',
  globalScormTenantId: 'f9fd2f2b-c575-43b2-bc20-8b2369137fe7',
  searchApiUrl: 'https://app.uat.anti-infectives.modaldigital.io/apis/rustici-course-search',
  searchApiBearerToken: 'w8sgOcUsvGyv5vGQ-FomGTcTNdF0mu4HUp_5_4VgEzs',
  recommendationsApiUrl: 'https://eventually-something/generate_recommendations',
  emailBearerToken: 'OAfGOYqmeCHkPCzF',
  authConfig: {
    domain: 'auth.uat.anti-infectives.modaldigital.io',
    clientId: 'PL5jT09zShG5pyYGgaacyjzQQ7sdz3G9',
    audience: 'https://app.uat.anti-infectives.modaldigital.io',
    responseType: 'token id_token'
  },
  firebaseConfig: {
    apiKey: 'AIzaSyDc3QrEjbm4ejxpJdH7b2tUwP23Fvt847s',
    authDomain: 'modal-anti-infectives-uat.firebaseapp.com',
    databaseURL: 'https://modal-anti-infectives-uat-default-rtdb.firebaseio.com',
    projectId: 'modal-anti-infectives-uat',
    storageBucket: 'modal-anti-infectives-uat.firebasestorage.app',
    messagingSenderId: '240313934362',
    appId: '1:240313934362:web:4af0e48dd852c7558c67a3',
    measurementId: 'G-N7PKWV5R7S',
    vapidKey:
      'BOpar64HYrvPbn8VZopAUyB1mqzYvW3ChfSiYvCC18mzm6sQHI80lswCydOUaeX58HxPx_Orj7FoZ6jXVc-D36M',
    fallbackUrl: 'https://bocoweb.prod.bocodigital.com/ios/apps/delphire-antiinfectives-uat/v4',
    iamId: 'modal-anti-infectives-uat-state'
  },
  pspdfkit: {
    nativeLicense:
      '',
    license:
      '',
  },
  firebasePaths: {
    state: 'environment/production/iam/state/',
    space: 'environments/production/'
  },
  appLanguage: {
    general: {
      networkConnectionMessageHeader: 'Network connection is required',
      networkConnectionMessage:
        'I am sorry. To use this resource, you must be connected to the Internet.',
      connectionLost: 'Your connection to the internet was lost.',
      connectionFound: 'Your internet connection seems to have returned.',
      reloadMessage: 'Please press OK to reload.',
      showMe: 'Show Me',
      downLoading: 'Downloading',
      dismiss: 'Dismiss',
      disclaimer:
        'Confidential – For internal educational use only. Execution to content must align to role responsibilities and comply with company policies & procedures.'
    },
    topNav: {
      loggedInAs: 'Logged in as',
      since: 'since',
      availableLayouts: 'Available Layouts',
      favorites: 'Favorites',
      preferences: 'Preferences',
      logOutNow: 'Logout now',
      yes: 'Yes',
      no: 'No',
      areYouSure: 'Are you sure?',
      sorry: 'Sorry',
      okay: 'Okay',
      maybeLater: 'Maybe Later'
    },
    modals: {
      workingOffline: 'You are working offline',
      preferences: {
        profile: 'Profile',
        dataManagement: 'Data Management',
        total: 'Total',
        allStorage: 'All Storage',
        features: 'Features',
        notifications: 'Notifications',
        defaultLayout: 'Default dashboard',
        defaultLayoutMessage:
          'Select a dashboard below to change the default dashboard.',
        defaultLayoutDisclaimer:
          'the dashboard can always be changed using the drop down menu at the top right at any time.',
        close: 'Close'
      },
      updateInProgressHeader: 'Update in progress',
      updateInProgressMessage:
        'Your dashboard and resources are being updated to reflect recent changes.',
      contentUnavailableHeader: 'This content is no longer available.',
      contentUnavailableMessage:
        'This content has been disabled. Please return to the main dashboard.',
      chooseLayoutHeader: 'Would you like to make this your default dashboard?',
      chooseLayoutMessage:
        'You can change the dashboard later by clicking on the avatar in the upper right corner of the application. You can also change your default dashboard by going to preferences.',
      logout: 'Logout',
      logOutMessage: 'You will be redirected to the login screen momentarily.'
    },
    widget: {
      disabled: 'Disabled',
      waiting: 'Waiting',
      week: 'Week',
      todaysTasks: 'Todays Tasks',
      noTasks: 'Today there are no tasks.',
      youHaveNoTasks: '',
      forCurrentWeek: '',
      minutes: 'mins',
      keyObjectives: 'Key Objectives',
      todoThisWeek: 'Tasks for this week'
    },
    library: {
      noFavoritesHeader: 'No favorites',
      noFavoritesMessage: 'You have not marked any favorites.',
      folderMessage: 'inside this folder',
      pages: 'pages',
      open: 'Open',
      myFavorites: 'My Favorites'
    },
    agenda: {
      viewPdf: 'View PDF',
      time: 'Time',
      description: 'Description',
      location: 'Location'
    },
    roadmap: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      week: 'Week',
      noTasksThisDay: '',
      checkAll: 'Check all',
      unCheckAll: 'Uncheck all',
      acknowledgement: 'Acknowledge',
      acknowledgementModalSubmit: 'Acknowledge'
    },
    quiz: {
      quiz: 'Knowledge Check',
      begin: 'Begin',
      close: 'Close',
      submit: 'Submit',
      correct: 'Correct',
      incorrect: 'Incorrect',
      continue: 'Continue',
      sorry: 'You did not successfully achieve a passing score.',
      congratulations: 'Congratulations!'
    }
  }
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
